import React from 'react';
import { Card, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

export type WorkOrderStatusKey =
  | 'new' | 'scheduled' | 'in_progress' | 'waiting_parts' | 'waiting_approval' | 'completed';

interface PipelineBarProps {
  counts: Record<WorkOrderStatusKey, number>;
}

const STAGES: Array<{ key: WorkOrderStatusKey; label: string; color: string }> = [
  { key: 'new',              label: 'New',            color: '#1890ff' },
  { key: 'scheduled',        label: 'Scheduled',      color: '#722ed1' },
  { key: 'in_progress',      label: 'In Progress',    color: '#52c41a' },
  { key: 'waiting_parts',    label: 'Waiting Parts',  color: '#fa8c16' },
  { key: 'waiting_approval', label: 'Needs Approval', color: '#ff4d4f' },
  { key: 'completed',        label: 'Completed',      color: '#8c8c8c' },
];

const PipelineBar: React.FC<PipelineBarProps> = ({ counts }) => {
  const navigate = useNavigate();
  const max = Math.max(1, ...STAGES.map((s) => counts[s.key] || 0));

  return (
    <Card title="Open Work Orders by Stage" size="small">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {STAGES.map((s) => {
          const n = counts[s.key] || 0;
          const widthPct = Math.round((n / max) * 100);
          return (
            <button
              key={s.key}
              type="button"
              aria-label={s.label}
              onClick={() => navigate(`/owner/work-orders?status=${s.key}`)}
              style={{
                display: 'grid',
                gridTemplateColumns: '140px 1fr 32px',
                alignItems: 'center',
                gap: 8,
                background: 'transparent',
                border: 'none',
                padding: '4px 0',
                cursor: 'pointer',
                textAlign: 'left',
              }}
            >
              <Text>{s.label}</Text>
              <div style={{ height: 10, background: '#f0f0f0', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ width: `${widthPct}%`, height: '100%', background: s.color }} />
              </div>
              <Text strong>{n}</Text>
            </button>
          );
        })}
      </div>
    </Card>
  );
};

export default PipelineBar;
